import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class DataService {

  public cardDetails: any;
  public cardType = new BehaviorSubject<Object>(null);
  public giftCardsImageUrl: any;
  public voucherDetails: any;

  constructor() { }

  setCardType(val: Object) {
    this.cardType.next(val);
  }

  getCardType() {
    return this.cardType.asObservable();
  }

  getpublicKey() {
    return environment.keys.publicKey;
  }

  setVoucherDetails(obj: any) {
    this.voucherDetails = obj;
  }

  getVoucherDetails() {
    const obj: any = { voucherDetails: this.voucherDetails }
    return obj;
  }
}
